



/** Helper to convert hex to rgba (falls back to returned value if already rgba) */
export const hexToRgba = (color: string, alpha: number) => {
    if (!color) return `rgba(0,0,0,${alpha})`;
    const c = color.trim();
    if (c.startsWith('rgb')) {
        // already rgb/rgba
        return c.includes('rgba') ? c : c.replace('rgb(', 'rgba(').replace(')', `, ${alpha})`);
    }
    if (c.startsWith('#')) {
        let hex = c.slice(1);
        if (hex.length === 3) {
            hex = hex.split('').map(h => h + h).join('');
        }
        if (hex.length === 6 || hex.length === 8) {
            const r = parseInt(hex.slice(0, 2), 16);
            const g = parseInt(hex.slice(2, 4), 16);
            const b = parseInt(hex.slice(4, 6), 16);
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        }
    }
    return c;
};